import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import routesNew from './routesComp'
import { RouterTabRoutes } from 'vue-router-tab'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../components/layout/Frame.vue'),
    meta: {
      title: 'Inicio | S.I Flota Vehicular',
    },
    children: [
      ...RouterTabRoutes,
      ...routesNew,
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/Login/Login.vue'),
    meta: {
      libre : true,
      title: 'Login | S.I Flota Vehicular',
      keepAlive: true,
    }
  },
]


const router = new VueRouter({
  mode: 'hash',
  routes
})


router.beforeEach((to,from,next)=>{
  const defaultTitle = ' S.I Flota Vehicular'
  document.title = to.meta.title || defaultTitle

  if (to.matched.some(record => record.meta.libre)){
    next()
  }
  else if (store.getters.getUser && store.getters.getRol == 'Administrador'){
    if(to.matched.some(record => record.meta.administrador)){
      next()
    }
  }
  else if (store.getters.getUser && store.getters.getRolPer == 'ACCESO_SISTEMA' && store.getters.getRol != 'Administrador'){
    if(to.matched.some(record => record.meta.operador)){
      next()
    }
  }
  else{
    next({
      name:'login'
    })
  }
});

export default router
